// extracted by mini-css-extract-plugin
export default {"text":"Location_text__w8VAr","container":"Location_container__abOH7"};